import { Swiper, Autoplay, EffectFade, } from 'swiper/swiper.esm.js';

export default class BgImgSlider {
  constructor(bgImgSlider) {
    Swiper.use([Autoplay, EffectFade]);

    var mySwiper = new Swiper(bgImgSlider, {
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      spaceBetween: 0,
      slidesPerView: 'auto',
      loop: 'true',
      effect: 'fade',
      speed: 1000,
    });
  }
}
